import React, { useState } from "react";
import { IoMdCheckmark, IoMdClose } from "react-icons/io";
import { useGlobalContext } from "../../../Contexts/GlobalContext";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { RxCross2 } from "react-icons/rx";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import axios from "axios";
import { BASE_URL } from "../../../Utlils";
import { addTeamMember } from "../../../Actions/globalActions";
import LoaderBTN from "../../../components/LoaderBTN";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
};

const MyMembers = () => {
  const { teamMembers, user, setSnackbar, getTeamMembers, organization } =
    useGlobalContext();
  const [open, setOpen] = useState(false);
  const [inputData, setInputData] = useState({ permission: [] });
  const [buttonLoader, setButtonLoader] = useState(false);
  const handleClose = (e) => setOpen(false);

  const handleAddMember = async (e) => {
    e.preventDefault();
    setButtonLoader(true);
    try {
      const emailDomains = ["gmail", "hotmail", "yahoo", "outlook"];
      if (emailDomains.some((domain) => inputData?.email?.includes(domain))) {
        setSnackbar({
          msg: "Please use corporate email !",
          open: true,
          severity: "error",
        });
        setButtonLoader(false);
        return;
      }
      await addTeamMember({
        ...inputData,
        organizationName: organization?.name,
        organizationOwner: false,
        organizationId: organization?.id,
        authorize: false,
        projectSettings: organization?.projectSettings,
        invitedBy: user?.personalDetails?.fullName,
        name: inputData?.personalDetails?.fullName,
      })
        .then((res) => {
          setOpen(false);
          getTeamMembers();
          setSnackbar({
            msg: "Member Added Successfully !",
            open: true,
            severity: "success",
          });
          setInputData({ permission: [] });
        })
        .catch((er) => {
          console.log(er);
          let errorMessage = er?.response.data?.message;
          if (
            errorMessage?.includes("Unable") ||
            errorMessage?.includes("exists")
          ) {
            setSnackbar({
              msg: errorMessage,
              open: true,
              severity: "error",
            });
          } else {
            setSnackbar({
              msg: "Something went wrong !",
              open: true,
              severity: "error",
            });
          }
        });
      setButtonLoader(false);
    } catch (error) {
      setSnackbar({
        msg: "Something went wrong !",
        open: true,
        severity: "error",
      });
      setButtonLoader(false);
    }
  };
  //EDIT ROLE & ACCESS:
  const editMembersAccess = async (
    accessName,
    id,
    authorization,
    accountStatus
  ) => {
    try {
      const update = await axios.put(
        `${BASE_URL}/users-access?userId=${id}`,
        accessName !== null
          ? {
              role: accessName,
              permission: accessName == "admin" ? ["PB", "GB"] : ["PB"],
            }
          : authorization !== null
          ? { authorize: authorization }
          : { accountStatus: accountStatus }
      );
      setSnackbar({
        msg: "Member Details Updated Successfully !",
        open: true,
        severity: "success",
      });
      getTeamMembers();
      // getUser();
    } catch (error) {
      // console.log(error);
      setSnackbar({
        msg: "Something went wrong !",
        open: false,
        severity: "error",
      });
    }
  };
  // console.log("user=>", user);
  // console.log("inputData=>", inputData);
  return (
    <div className="w-full flex flex-col gap-6 h-full py-5">
      <div className="pb-6 flex items-center justify-between border-b border-gray-200">
        <div className="flex flex-col gap-2 justify-center">
          <h1 className="text-[#0226BE] text-[28px] font-[600]">Members</h1>
          <p className="text-gray-600 text-[14px]">Manage team members and their access permissions</p>
        </div>
        {user?.role?.toLowerCase() === "admin" ? (
          <button
            className="bg-[#0226BE] rounded-md text-white px-5 text-[14px] py-2.5 font-[500] hover:bg-[#021ea8] transition-colors"
            onClick={(e) => setOpen(true)}
          >
            Add Member
          </button>
        ) : (
          ""
        )}
      </div>
      <div className="w-full border border-gray-200 rounded-lg overflow-hidden bg-white">
        <div className="w-full overflow-y-auto containerScroll">
          <table
            className="whitespace-nowrap text-left w-full"
            id="table-to-xls-DATA"
          >
            <thead className="bg-gray-50">
              <tr>
                {[
                  "Account Name",
                  "Allocation",
                  "Project Based Access",
                  "Global Member Access",
                  "Account Status",
                ]?.map((data, ind) => (
                  <th key={ind} className="text-gray-700 text-[14px] font-[600] px-4 py-3">
                    {data}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {teamMembers?.map((data, ind) => (
                <tr key={ind} className="border-b border-gray-100 transition-all hover:bg-blue-50">
                  <td className="px-4 py-3 text-[#1a1a1a] font-[500] text-[14px]">
                    <h1 className="whitespace-normal text-ellipsis overflow-hidden">
                      {data?.personalDetails?.fullName}{" "}
                      {data?._id === user?._id ? <span className="text-gray-500">(You)</span> : ""}
                    </h1>
                  </td>
                  <td className="px-4 py-3 text-[#1a1a1a] font-[400] text-[14px]">
                    <select
                      className="border border-gray-300 py-2 px-3 capitalize rounded-md text-[14px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all disabled:bg-gray-50 disabled:cursor-not-allowed"
                      value={data?.role}
                      disabled={
                        data?._id === user?._id ||
                        user?.role?.toLowerCase() !== "admin"
                      }
                      onChange={(e) => {
                        if (user?.role?.toLowerCase() === "admin") {
                          editMembersAccess(
                            e.target.value,
                            data?._id,
                            null,
                            null
                          );
                        } else {
                          setSnackbar({
                            msg: "Only Admin can change roles !",
                            open: true,
                            severity: "error",
                          });
                        }
                      }}
                    >
                      <option value="">Select Role</option>
                      {["member", "admin"]?.map((d, i) => (
                        <option key={i} value={d}>{d}</option>
                      ))}
                    </select>
                  </td>
                  <td className="px-4 py-3 text-[#667085] text-center font-[400] text-[14px]">
                    <div className="flex items-center justify-center">
                      {data?.permission?.includes("PB") ? (
                        <IoMdCheckmark size={20} className="text-green-600" />
                      ) : (
                        <IoMdClose size={20} className="text-red-500" />
                      )}
                    </div>
                  </td>
                  <td className="px-4 py-3 text-[#667085] font-[400] text-[14px]">
                    <div className="flex items-center justify-center">
                      {data?.permission?.includes("GB") ? (
                        <IoMdCheckmark size={20} className="text-green-600" />
                      ) : (
                        <IoMdClose size={20} className="text-red-500" />
                      )}
                    </div>
                  </td>
                  {/* <td className="px-3 py-2 text-[#667085] font-[400] text-[14px] ">
                    {data?.authorize ? (
                      <button
                        className="py-[6px]  rounded-[4px] text-[#F00] border border-[#F00] text-[14px] font-[500] inter w-[125px]"
                        onClick={(e) =>
                          editMembersAccess(null, data?._id, false, null)
                        }
                      >
                        Remove Access
                      </button>
                    ) : (
                      <button
                        className="py-[6px]  w-[125px] rounded-[4px] text-green-500 border border-green-500  text-[14px] font-[500] inter"
                        onClick={(e) =>
                          editMembersAccess(null, data?._id, true, null)
                        }
                      >
                        Allow Access
                      </button>
                    )}
                  </td> */}
                  <td className="px-4 py-3 text-[#667085] font-[400] text-[14px]">
                    {data?.accountStatus?.toLowerCase() === "active" ? (
                      <button
                        className="py-2 px-4 rounded-md text-red-600 border-2 border-red-600 text-[14px] font-[500] hover:bg-red-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                        disabled={
                          data?._id === user?._id ||
                          user?.role?.toLowerCase() !== "admin"
                        }
                        onClick={(e) => {
                          if (user?.role?.toLowerCase() === "admin") {
                            editMembersAccess(
                              null,
                              data?._id,
                              null,
                              "inactive"
                            );
                          } else {
                            setSnackbar({
                              msg: "Only Admin can change roles !",
                              open: true,
                              severity: "error",
                            });
                          }
                        }}
                      >
                        Deactivate
                      </button>
                    ) : (
                      <button
                        className="py-2 px-4 rounded-md text-green-600 border-2 border-green-600 text-[14px] font-[500] hover:bg-green-50 transition-colors"
                        onClick={(e) => {
                          if (user?.role?.toLowerCase() === "admin") {
                            editMembersAccess(null, data?._id, null, "active");
                          } else {
                            setSnackbar({
                              msg: "Only Admin can change roles !",
                              open: true,
                              severity: "error",
                            });
                          }
                        }}
                      >
                        Activate
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <div className="w-full flex items-center flex-col bg-white rounded-lg">
              <div className="w-full py-5 px-6 border-b border-gray-200 text-left relative">
                <h1 className="text-[#0226BE] text-[20px] font-[600]">
                  Add New Member
                </h1>
                <button
                  className="absolute top-4 right-4 p-1.5 hover:bg-gray-100 rounded-full cursor-pointer transition-colors"
                  onClick={handleClose}
                >
                  <RxCross2 size={18} className="text-gray-600" />
                </button>
              </div>

              <form
                className="w-full py-5 px-6 flex flex-col gap-5"
                onSubmit={handleAddMember}
              >
                <div className="flex flex-col gap-2">
                  <label className="text-[#1a1a1a] text-[14px] font-[500]">
                    Account Name
                  </label>
                  <input
                    type="text"
                    name="account name"
                    value={inputData?.personalDetails?.fullName}
                    onChange={(e) =>
                      setInputData((prev) => ({
                        ...prev,
                        personalDetails: {
                          ...prev?.personalDetails,
                          fullName: e.target.value,
                        },
                      }))
                    }
                    required
                    placeholder="Enter account name"
                    className="border border-gray-300 rounded-md pl-4 pr-4 h-[48px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all duration-200 text-[14px] placeholder:text-gray-400"
                  />
                </div>
                <div className="flex flex-col gap-2">
                  <label className="text-[#1a1a1a] text-[14px] font-[500]">
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={inputData?.email}
                    onChange={(e) =>
                      setInputData((prev) => ({
                        ...prev,
                        email: String(e.target.value)?.toLowerCase(),
                      }))
                    }
                    required
                    placeholder="Enter email address"
                    className="border border-gray-300 rounded-md pl-4 pr-4 h-[48px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all duration-200 text-[14px] placeholder:text-gray-400"
                  />
                </div>
                <div className="flex flex-col gap-2">
                  <label className="text-[#1a1a1a] text-[14px] font-[500]">
                    User Role
                  </label>
                  <select
                    className="border border-gray-300 rounded-md pl-4 pr-10 h-[48px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all duration-200 text-[14px] appearance-none bg-white bg-[url('data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22currentColor%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3e%3cpolyline points=%226 9 12 15 18 9%22%3e%3c/polyline%3e%3c/svg%3e')] bg-[length:20px] bg-[right_12px_center] bg-no-repeat cursor-pointer capitalize"
                    name="supplierAccount"
                    required
                    value={inputData?.role}
                    onChange={(e) =>
                      setInputData((prev) => ({
                        ...prev,
                        role: e.target.value,
                        permission:
                          e.target.value == "member" ? ["PB"] : ["PB", "GB"],
                      }))
                    }
                  >
                    <option value="" disabled>
                      Select User Role
                    </option>
                    {["member", "admin"]?.map((d, i) => (
                      <option key={i} value={d}>{d}</option>
                    ))}
                  </select>
                </div>
                <div className="flex flex-col gap-[15px]">
                  <label className="text-[#333] text-[14px] font-[500]">
                    Members Role Accessibility
                  </label>
                  <div className="flex items-center gap-[38px] pl-2">
                    <div className="flex items-center gap-[10px] ">
                      <input
                        type="checkbox"
                        name="project base"
                        id="project base"
                        checked={inputData?.permission?.includes("PB")}
                        // onChange={(e) => {
                        //   setInputData((prev) => ({
                        //     ...prev,
                        //     permission: e.target.checked
                        //       ? [...prev.permission, "PB"]
                        //       : prev?.permission?.filter((d) => d !== "PB"),
                        //   }));
                        // }}
                        // required={!inputData?.permission?.length}
                        placeholder="Enter Email"
                        className="border border-[#E2E2E5] rounded-[4px] pl-2 h-[17px] focus:outline-none w-[17px]"
                      />
                      <label
                        htmlFor="project base"
                        className="text-[#333] text-[14px] font-[500]"
                      >
                        Project Base
                      </label>
                    </div>
                    <div className="flex items-center gap-[10px] ">
                      <input
                        type="checkbox"
                        name="global access"
                        id="global access"
                        // required={!inputData?.permission?.length}
                        checked={inputData?.permission?.includes("GB")}
                        // onChange={(e) => {
                        //   setInputData((prev) => ({
                        //     ...prev,
                        //     permission: e.target.checked
                        //       ? [...prev.permission, "GB"]
                        //       : prev?.permission?.filter((d) => d !== "GB"),
                        //   }));
                        // }}
                        placeholder="Enter Email"
                        className="border border-[#E2E2E5] rounded-[4px] pl-2 h-[17px] focus:outline-none w-[17px]"
                      />
                      <label
                        htmlFor="global access"
                        className="text-[#333] text-[14px] font-[500]"
                      >
                        Global Base
                      </label>
                    </div>
                  </div>
                </div>
                <div className="flex justify-end gap-3 pt-2">
                  <button
                    type="button"
                    onClick={handleClose}
                    className="border-2 border-gray-300 rounded-md py-2.5 px-5 text-[14px] font-[500] text-gray-700 hover:bg-gray-50 transition-colors"
                  >
                    Cancel
                  </button>
                  {buttonLoader ? (
                    <LoaderBTN
                      msg={<h1 className="text-[#0226BE]/50">Adding...</h1>}
                    />
                  ) : (
                    <button
                      type="submit"
                      disabled={buttonLoader}
                      className="bg-[#0226BE] text-white text-[14px] font-[500] rounded-md py-2.5 px-5 hover:bg-[#021ea8] transition-colors disabled:opacity-50"
                    >
                      Add Member
                    </button>
                  )}
                </div>
              </form>
            </div>
          </Box>
        </Fade>
      </Modal>
      <div className="pt-5"></div>
    </div>
  );
};

export default MyMembers;
